import { Fragment, type ReactNode } from "react";
import { Link } from "wouter";
import { I } from "./Icons";
import { PresenceStack } from "./PresenceAvatars";

interface Crumb {
  t: string;
  strong?: boolean;
  href?: string;
}

interface Props {
  crumbs: Crumb[];
  right?: ReactNode;
}

export function TopBar({ crumbs, right }: Props) {
  return (
    <div className="gf-top">
      <div className="gf-crumbs">
        {crumbs.map((c, i) => (
          <Fragment key={i}>
            {i > 0 && <I.ChevronRight size={12} />}
            {c.strong ? (
              <b>{c.t}</b>
            ) : c.href ? (
              <Link href={c.href}>{c.t}</Link>
            ) : (
              <span>{c.t}</span>
            )}
          </Fragment>
        ))}
      </div>
      <div className="gf-top__actions">
        <PresenceStack />
        {right || (
          <>
            <button
              className="gf-btn gf-btn--ghost"
              style={{ padding: "8px 10px" }}
            >
              <I.Search size={15} />
            </button>
            <button
              className="gf-btn gf-btn--ghost"
              style={{ padding: "8px 10px", position: "relative" }}
            >
              <I.Bell size={15} />
              <span
                style={{
                  position: "absolute",
                  top: 6,
                  right: 6,
                  width: 6,
                  height: 6,
                  borderRadius: 999,
                  background: "var(--danger)",
                }}
              ></span>
            </button>
          </>
        )}
      </div>
    </div>
  );
}
